
import ApartmentList from '../../features/marketingExecutive/ApartmentList'

const ZonalCoordinatorAddApartmentPage = () => {
  return (
  <ApartmentList/>
  )
}

export default ZonalCoordinatorAddApartmentPage